module.exports = __webpack_public_path__ + "img/tv-icon.2a61ddd4.svg";